var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmitRequest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16832",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12488",
    d: "M12.472 11.908V7.477A1.477 1.477 0 0010.995 6h0a1.476 1.476 0 00-1.476 1.477V16l-2.646-1.358a1.558 1.558 0 00-1.813.284h0a1.558 1.558 0 00.065 2.264l4.825 4.3a2 2 0 001.331.51h4.633a2 2 0 001.952-1.566l1.189-5.351a2 2 0 00-1.646-2.41z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12489",
    d: "M12.643 9H17a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v2a2 2 0 002 2h4.357"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12490",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default SvgSubmitRequest;


//////////////////
// WEBPACK FOOTER
// ./src/icons/submitRequest.svg
// module id = 467
// module chunks = 13